import { ReactNode, useState } from 'react';
import { ChevronDown } from '../../../../../components/icons';

interface Props {
  children: ReactNode;
  className?: string;
  title: string;
}

function ProductDetailSection(props: Props) {
  const [closed, setClosed] = useState(false);

  return (
    <div
      className={`py-6 space-y-2 md:space-y-3 ${
        props.className || ''
      }`}
    >
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setClosed((prev) => !prev)}
      >
        <h4 className="font-bold text-2xl tracking-tighter text-greyscale-title m-0 p-0">
          {props.title}
        </h4>
        <ChevronDown
          className={`text-greyscale-title transition ease-in-out duration-200 ${
            closed ? 'rotate-180' : ''
          }`}
        />
      </div>
      {!closed && <div>{props.children}</div>}
    </div>
  );
}

export default ProductDetailSection;
